/**
 * Sync — remap archival Player FKs from an ingested batch to canonical
 * Players so runs/wickets accrue on real profile stats.
 *
 * Two scopes share the same engine:
 *   * Competition — bulk clean-up right after ingest (all matches).
 *   * Match       — surgical single-match fix from the Matches admin
 *                   drill-down. Payload shape mirrors competition, with
 *                   `preview.match` in place of `preview.competition`.
 * Endpoints live under /api/admin/v2/, IsSuperuser-gated.
 */
import api from "./axios";

export const getTournamentSyncPreview = (competitionId) =>
  api.get(`/api/admin/v2/tournament-sync/${competitionId}/preview/`);

export const commitTournamentSync = (competitionId, mappings) =>
  api.post(`/api/admin/v2/tournament-sync/${competitionId}/commit/`, {
    mappings,
  });

export const getMatchSyncPreview = (matchId) =>
  api.get(`/api/admin/v2/match-sync/${matchId}/preview/`);

export const commitMatchSync = (matchId, mappings) =>
  api.post(`/api/admin/v2/match-sync/${matchId}/commit/`, {
    mappings,
  });
